<template>
    <div id="backStandard">
        <my-header></my-header>
        <div class="banner">
            <img src="../../../assets/images/invitemanage/topBg.jpg" />
            <div class="main-container">
                <div class="bannerText">
                    <h2>{{ projectName }}<span>回标</span></h2>
                    <p>{{ endTime ? "回标截止时间：" + endTime : "" }}</p>
                </div>
            </div>
        </div>

        <div class="main-container mainWrap">
            <div
                class="small-container titleWrap"
                v-if="$route.params.purchaseType != 1"
            >
                <el-menu
                    default-active="1"
                    class="el-menu-demo"
                    mode="horizontal"
                >
                    <el-menu-item index="1">{{ sn }}</el-menu-item>
                </el-menu>
            </div>
            <section class="small-container">
                <p>
                    <span class="tips" style="color: #cb1235;"
                        >上传附件大小不要超过1G</span
                    >
                </p>
            </section>
            <!--比价议标-->
            <section class="small-container" v-if="techender == 0">
                <h3>技术标</h3>
                <el-form
                    label-position="left"
                    :model="technologyForm"
                    :rules="technologyRules"
                    status-icon
                    ref="technologyForm"
                    label-width="180px"
                    class="technologyForm"
                >
                    <el-row>
                        <el-col :span="24">
                            <el-form-item
                                prop="mergeList"
                                label="技术标附件："
                                class="tipIcon"
                            >
                                <page-upload
                                    :files="technologyForm.mergeList"
                                    class="uploadFloat"
                                    v-on:finishUpload="finishUploadMergeFile"
                                    :editFlag="isEdit"
                                    attachmentType="110"
                                    :limitType="2"
                                    :isIconTable="2"
                                    :notMany="false"
                                    :disable="isEdit ? '' : 1"
                                ></page-upload>
                                <!--:notViewList="true"-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <section class="small-container">
                <h3>
                    商务标<span class="tips" style="margin-left: 30px;"
                        >请确认价格输入准确！</span
                    >
                </h3>
                <el-form
                    label-position="left"
                    :model="commerceForm"
                    :rules="commerceRules"
                    status-icon
                    ref="commerceForm"
                    label-width="180px"
                    class="commerceForm"
                >
                    <el-row>
                        <el-col :span="12">
                            <el-form-item
                                label="报价（含税，元）："
                                prop="returnPriceTax"
                            >
                                <el-input
                                    :disabled="!isEdit"
                                    v-model="commerceForm.returnPriceTax"
                                    :maxlength="20"
                                    @change="sectionChange()"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="税率（%）："
                                prop="itemTaxRate"
                                label-width="150px"
                            >
                                <!-- <el-select :disabled="!isEdit" size="mini" v-model="commerceForm.taxRate" @change="sectionChange()">
                                    <el-option
                                        v-for="item in rateTypeOptions"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                    </el-option>
                                </el-select> -->
                                <el-input
                                    :disabled="!isEdit"
                                    readonly
                                    autosize
                                    style="width:100%"
                                    v-model="taxFullName"
                                    type="textarea"
                                    @focus="chooseTax()"
                                    @change="sectionChange()"
                                    suffix-icon="el-icon-search"
                                    placeholder="选择税率"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                label="报价（不含税，元）："
                                prop="returnPriceNotax"
                            >
                                <el-input
                                    disabled
                                    v-model="commerceForm.returnPriceNotax"
                                    :maxlength="20"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计价方式：" required>
                                <span>{{ commerceForm.taxWayText }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="商务标附件："
                                prop="business"
                                class="uploadItem"
                            >
                                <page-upload
                                    :files="commerceForm.business"
                                    class="uploadFloat"
                                    v-on:finishUpload="finishUploadFile"
                                    :editFlag="true"
                                    :attachmentType="
                                        $route.params.purchaseType == 0
                                            ? 93
                                            : 111
                                    "
                                    :limitType="2"
                                    :isIconTable="2"
                                    :notMany="false"
                                    :disable="isEdit ? '' : 1"
                                ></page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <div style="margin: 40px 0 0;" v-if="isEdit">
                <el-button
                    class="cancelBtn"
                    style="padding: 10px 40px;font-size: 14px;background: #cfcfcf;"
                    @click="cancel"
                    >取消</el-button
                >
                <el-button
                    type="primary"
                    style="padding: 10px 40px;font-size: 14px;"
                    @click="submit"
                    >提交</el-button
                >
            </div>
        </div>
        <!-- 选择税目 -->
        <select-tax ref="selectTax" @callback="selectedTax"></select-tax>
    </div>
</template>
<script type="text/babel">
import MyHeader from "../MasterHeader.vue";
import selectTax from "@/pages/common/selectTax";

export default {
    name: "backStandard",
    data() {
        var checkFile = function(rule, value, callback) {
            if (value.length) {
                callback();
            } else {
                callback(new Error("附件不能为空"));
            }
        };
        return {
            taxFullName: "",
            formId: "", //当前跳转的路由id
            cancelId: "", //点击取消时的路由id
            sn: "", //当前是标段几；
            isEdit: true, //是否可以上传
            projectName: "", //项目名称
            endTime: "", //截止时间
            rateTypeOptions: [], //税率
            commerceForm: {
                //商务标
                returnPriceTax: "", //进项税
                returnPriceNotax: "", //报价
                business: [], //商务标附件
                disPlayValorem: "", //计价方式code
                taxWayText: "", //计价方式
                itemTaxRate: "",
                itemTaxName: "",
                itemTaxId: ""
            },
            commerceRules: {
                returnPriceTax: [
                    { required: true, message: "报价不能为空" },
                    { validator: this.checkDeg, trigger: "blur" }
                ],
                returnPriceNotax: [
                    { required: true, message: "报价不能为空" },
                    { validator: this.checkDeg, trigger: "blur" }
                ],
                itemTaxRate: [
                    {
                        required: true,
                        message: "税率不能为空",
                        trigger: "change"
                    }
                ],

                business: [
                    { required: true, validator: checkFile, trigger: "change" }
                ]
            },
            technologyForm: {
                //技术标
                bright: [], //明标
                dark: [], //暗标
                mergeList: [] //直接议标下的技术标
            },
            technologyRules: {
                mergeList: [
                    { required: true, validator: checkFile, trigger: "change" }
                ],
                dark: [
                    { required: true, validator: checkFile, trigger: "change" }
                ]
            },
            techender: 0, //0 有技术标，1 没有技术标
            darkTender: 0, //0 有技术暗标，1 没有技术暗标
            obj:
                JSON.parse(window.sessionStorage.getItem("backStandardData")) ||
                {}
        };
    },
    components: { MyHeader,selectTax },
    created() {
        this.$root.activeIndex = "win";
        if (this.$route.params.entrance == 1) {
            //entrance 1 代表从标段的title按钮进入的，可上传 提交
            this.isEdit = true;
        } else {
            //entrance 2 代表从垂直的历史进度条进入的，不可上传 提交
            this.isEdit = false;
        }
        this.formId = this.obj.dealBisVo.flowFormExtMng.id;
        this.cancelId = this.obj.dealBisVo.flowFormExtMng.id;
        this.projectName = this.obj.dealBisVo.flowFormExtMng.formTitle;
        this.endTime = this.obj.endTime;
        this.commerceForm.returnPriceTax = this.obj.businessBidVo.returnPriceTax;
        this.commerceForm.returnPriceNotax = this.obj.businessBidVo.returnPriceNotax;
        this.commerceForm.itemTaxRate = this.obj.businessBidVo.itemTaxRate || '';
        this.commerceForm.itemTaxName = this.obj.businessBidVo.itemTaxName || '';
        this.commerceForm.itemTaxId = this.obj.businessBidVo.itemTaxId;
        this.taxFullName = this.commerceForm.itemTaxId ?  `${this.commerceForm.itemTaxName}(${this.commerceForm.itemTaxRate}%)` : '';

        //            this.commerceForm.disPlayValorem = obj.disPlayValorem;//计价方式
        this.sn = this.obj.sn;
        this.techender = this.obj.techender;
        this.darkTender = this.obj.darkTender;

        this.obj.businessBidVo.business &&
            (this.commerceForm.business = this.obj.businessBidVo.business);
        if (this.obj.technologyBidVo) {
            this.obj.technologyBidVo.mergeList &&
                (this.technologyForm.mergeList = this.obj.technologyBidVo.mergeList);
        }
        this.getType("tax_rate_type");
    },
    mounted() {
        window.backObj = this;
        if (this.obj.disPlayValorem == "0") {
            this.commerceForm.taxWayText = "一般计税";
        } else if (this.obj.disPlayValorem == "1") {
            this.commerceForm.taxWayText = "简易征收";
        } else if (this.obj.disPlayValorem == "0,1") {
            this.commerceForm.taxWayText = "一般计税，简易征收";
        } else if (this.obj.disPlayValorem == "1,0") {
            this.commerceForm.taxWayText = "简易征收，一般计税";
        }
    },
    methods: {
        selectedTax(val) {
            console.log("选择税目", val);
            this.commerceForm.itemTaxRate = val.taxRate;
            this.commerceForm.itemTaxName = val.name;
            this.commerceForm.itemTaxId = val.id;
            this.taxFullName = `${this.commerceForm.itemTaxName}(${this.commerceForm.itemTaxRate}%)`;
            this.sectionChange();
        },
        chooseTax() {
            this.$refs["selectTax"].show();
        },
        sectionChange() {
            if (
                this.commerceForm.returnPriceTax &&
                this.commerceForm.itemTaxRate
            ) {
                this.commerceForm.returnPriceNotax =
                    (parseFloat(this.commerceForm.returnPriceTax) * 100) /
                    (100 + parseInt(this.commerceForm.itemTaxRate));
                this.commerceForm.returnPriceNotax = this.commerceForm.returnPriceNotax.toFixed(
                    2
                );
                this.commerceForm.returnTaxPrice =
                    parseFloat(this.commerceForm.returnPriceTax) -
                    parseFloat(this.commerceForm.returnPriceNotax);
                this.commerceForm.returnTaxPrice = this.commerceForm.returnTaxPrice.toFixed(
                    2
                );
            }
        },
        getType(type) {
            let that = this;
            that.$root.getHttp(
                "v1/sysDict/public/getDictListByDictType?dictType=" + type,
                function(res) {
                    that.rateTypeOptions = res.data.data;
                }
            );
        },
        getLabel(i) {
            if (i == 0) {
                return "标段一";
            } else if (i == 1) {
                return "标段二";
            } else if (i == 2) {
                return "标段三";
            }
        },
        checkDeg(rule, value, callback) {
            let reg = /^\d+(\.\d{1,2})?$/;
            if (!reg.test(value)) {
                callback(new Error("请输入数字，且小数点后不超过两位"));
            } else {
                callback();
            }
        },
        finishUploadFile(val) {
          console.log(val);
            //文件上传完成后，同步商务标的数据；
            if (val.fileList.length) {
           
                // this.commerceForm.business = [];
                if(this.commerceForm.business.length <=3){
                 

                }else{
                  this.commerceForm.business.splice(3,1)
                  this.$alert("最多上传3个商务标附件", "提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                  });
                }
                /* if(this.commerceForm.business.length){
                        this.commerceForm.business[0].attachName = val.fileList[0].attachName;
                        this.commerceForm.business[0].attachPath = val.fileList[0].attachPath;
                        this.commerceForm.business[0].createByUsername = val.fileList[0].createByUsername;
                        this.commerceForm.business[0].attachSize = val.fileList[0].attachSize;
                    } else {
                        this.commerceForm.business[0]= {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath,
                            createByUsername:val.fileList[0].createByUsername,
                            attachSize: val.fileList[0].attachSize
                        };
                    } */
            }
        },
        finishUploadBrightFile(val) {
            //文件上传完成后，同步技术标明标的数据；
            if (val.fileList.length) {
                this.technologyForm.bright = [];
                this.technologyForm.bright.push(val.fileList[0]);
                /* if(this.technologyForm.bright.length){
                        this.technologyForm.bright[0].attachName = val.fileList[0].attachName;
                        this.technologyForm.bright[0].attachPath = val.fileList[0].attachPath;
                        this.technologyForm.bright[0].createByUsername = val.fileList[0].createByUsername;
                        this.technologyForm.bright[0].attachSize = val.fileList[0].attachSize;
                    } else {
                        this.technologyForm.bright[0] = {
                            attachName: val.fileList[0].attachName,
                            attachPath: val.fileList[0].attachPath,
                            createByUsername:val.fileList[0].createByUsername,
                            attachSize: val.fileList[0].attachSize
                        };
                    } */
            }
        },
        finishUploadDarkFile(val) {
            //文件上传完成后，同步技术标暗标的数据；
            if (val.fileList.length) {
                if (this.technologyForm.dark.length) {
                    this.technologyForm.dark[0].attachName =
                        val.fileList[0].attachName;
                    this.technologyForm.dark[0].attachPath =
                        val.fileList[0].attachPath;
                    this.technologyForm.dark[0].createByUsername =
                        val.fileList[0].createByUsername;
                    this.technologyForm.dark[0].attachSize =
                        val.fileList[0].attachSize;
                } else {
                    this.technologyForm.dark[0] = {
                        attachName: val.fileList[0].attachName,
                        attachPath: val.fileList[0].attachPath,
                        createByUsername: val.fileList[0].createByUsername,
                        attachSize: val.fileList[0].attachSize
                    };
                }
            }
        },
        finishUploadMergeFile(val) {
            //文件上传完成后，同步技术标 直接议标的数据；
            if (val.fileList.length) {
                if (this.technologyForm.mergeList.length) {
                    this.technologyForm.mergeList[0].attachName =
                        val.fileList[0].attachName;
                    this.technologyForm.mergeList[0].attachPath =
                        val.fileList[0].attachPath;
                    this.technologyForm.mergeList[0].createByUsername =
                        val.fileList[0].createByUsername;
                    this.technologyForm.mergeList[0].attachSize =
                        val.fileList[0].attachSize;
                } else {
                    this.technologyForm.mergeList[0] = {
                        attachName: val.fileList[0].attachName,
                        attachPath: val.fileList[0].attachPath,
                        createByUsername: val.fileList[0].createByUsername,
                        attachSize: val.fileList[0].attachSize
                    };
                }
            }
        },
        submitForm() {
            let that = this;
            let obj = {
                formId: that.$route.params.formId,
                subId: that.$route.params.id,
                purchaseType:
                    this.$route.params.purchaseType == 0
                        ? null
                        : this.$route.params.purchaseType,
                businessBidVo: {
                    returnPriceTax: that.commerceForm.returnPriceTax,
                    returnPriceNotax: that.commerceForm.returnPriceNotax,
                    returnTaxPrice: that.commerceForm.returnTaxPrice,
                    itemTaxRate: that.commerceForm.itemTaxRate,
                    itemTaxId: that.commerceForm.itemTaxId,
                    itemTaxName: that.commerceForm.itemTaxName,
                    business: that.commerceForm.business
                },
                technologyBidVo: {}
            };
            if (this.techender == 0) {
                obj.technologyBidVo.mergeList = that.technologyForm.mergeList;
            }

            if (!obj.businessBidVo.business) {
                //商务标必传
                that.$alert("带*的附件必须上传", "提示", {
                    confirmButtonText: "确定",
                    type: "warning"
                });
                return;
            }
            that.$root.postHttp(
                "/v1/outerformflow/backBid/submit",
                obj,
                function(res) {
                    that.$message.success("提交成功");
                    setTimeout(() => {
                        that.$router.push(
                            "/master/processManagement/" + that.formId + "/1"
                        );
                    }, 1000);
                }
            );
        },
        submit() {
            let that = this;
            this.$refs.commerceForm.validate(valid => {
                if (valid) {
                    if (this.techender == 0) {
                        //有技术标
                        that.$refs.technologyForm.validate(valid2 => {
                            if (valid2) {
                                that.submitForm();
                            } else {
                                that.$alert(
                                    "请把带*的必填字段填写完整",
                                    "提示",
                                    {
                                        confirmButtonText: "确定",
                                        type: "warning"
                                    }
                                );
                            }
                        });
                        // if(this.$route.params.purchaseType == 0){//邀请招标

                        // } else {
                        //     if(that.technologyForm.mergeList.length >0 && that.commerceForm.business.length>0){
                        //         that.submitForm();
                        //     } else {
                        //         that.$alert('请把带*的必填字段填写完整', '提示', {
                        //             confirmButtonText: '确定',
                        //             type: 'warning'
                        //         });
                        //     }
                        // }
                    } else {
                        that.submitForm();
                    }
                } else {
                    that.$alert("请把带*的必填字段填写完整", "提示", {
                        confirmButtonText: "确定",
                        type: "warning"
                    });
                    return false;
                }
            });
        },
        cancel() {
            //取消提交
            this.$router.push(
                "/master/processManagement/" + this.cancelId + "/1"
            );
        }
    }
};
</script>
<style lang="scss">
@import "../../../assets/var";
#backStandard {
    padding: 80px 0 50px;
    min-height: 85vh;
    background: $--primary-fill-color;
    & .head-top {
        background: #fff;
    }
    & .head-right {
        color: $--text-color-light;
        & .login {
            background: url("../../../assets/images/topBar2/icon07.png")
                no-repeat 0 1px;
        }
        & .register {
            background: url("../../../assets/images/topBar2/icon08.png")
                no-repeat 0 1px;
        }
        & .line {
            background: $--text-color-light;
        }
        & .help {
            background: url("../../../assets/images/topBar2/icon05.png")
                no-repeat;
        }
        & .wechat {
            background: url("../../../assets/images/topBar2/icon06.png")
                no-repeat;
        }
    }
    .banner {
        img {
            width: 100%;
            min-width: 1300px;
            height: 140px;
        }
        .main-container {
            position: relative;
            .bannerText {
                position: absolute;
                left: 0;
                top: -50px;
                width: 100%;
                color: #fff;
                line-height: 34px;
                h2 {
                    float: left;
                    font-size: 18px;
                    span {
                        display: inline-block;
                        vertical-align: middle;
                        border: 1px solid #fff;
                        padding: 0 8px;
                        margin-left: 15px;
                        height: 24px;
                        font-size: 14px;
                        line-height: 22px;
                        border-radius: 4px;
                        font-weight: normal;
                        box-sizing: border-box;
                    }
                }
                p {
                    float: right;
                    font-size: 14px;
                }
            }
        }
    }
    .mainWrap {
        position: relative;
        margin-top: 40px;
        padding-bottom: 60px;
        background: #fff;
    }
    .small-container {
        width: 1120px;
        margin: 0 auto;
        padding-top: 15px;
        & form {
            width: 95%;
            margin: 15px auto;
            .el-form-item {
                color: #333;
            }
            & .el-form-item__label {
                padding: 0 22px 0 0;
                color: #333;
            }
            & .el-form-item__content {
                width: 56%;
                text-align: left;
                & .el-select {
                    /*width: 35%;*/
                }
            }
        }
        .technologyForm {
            .el-form-item__error {
                left: 150px;
            }
        }
        & h3,
        & h4 {
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }
        & > p {
            text-align: right;
            /*margin-bottom: 10px;*/
        }
        & .tips {
            padding-left: 20px;
            font-weight: normal;
            font-size: 12px;
            color: $--text-color-light;
            background: url("../../../assets/images/register/icon03.png")
                no-repeat left center;
        }
        & .uploadItem {
            .el-form-item__content {
                width: 914px;
            }
        }
        & .tipIcon {
            position: relative;
            .el-form-item__content {
                position: static;
                width: 914px;
            }
            & strong {
                position: absolute;
                display: inline-block;
                border: 1px solid #000;
                background: #000;
                color: #fff;
                border-radius: 3px;
                font-weight: normal;
                line-height: 20px;
                padding: 0 5px;
                left: 95px;
                top: 9px;
            }
        }
    }
    .titleWrap {
        text-align: left;
    }
    .downLoadWrap {
        padding-top: 40px;
        text-align: left;
        font-size: 14px;
        .downBtn {
            padding: 20px 20px 0;
        }
        .fileName {
            margin-left: 30px;
            color: #333;
        }
        .fileName:hover {
            color: $--primary-color;
        }
    }
    .uploadFloat > div {
        float: left;
    }
    .file-list {
        margin-left: 50px;
    }
    .cancelBtn:hover,
    .cancelBtn:focus {
        border-color: rgb(207, 207, 207);
        color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/master/inviteProcess/BackStandard.vue